export default __webpack_public_path__ + "static/media/tools_light.f06024a8.png";